import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "./BannerCommon.module.css";
import usePopupVisibility from "../PopupForm/usePopupVisibility";
import { useRouter } from "next/router";
import PopupForm from "../PopupForm/PopupForm";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface CmsData {
  id: number;
  title: string;
  description: string;
  cta?: any;
  link: string;
  desktop_img: ImageData;
  mobile_img: ImageData;
}

interface BannerCommonProps {
  data?: any;
  cmsData?: CmsData;
  className?: string;
  classValue?: string;
  carrearpage?: boolean;
  popUpData?: any;
}

const BannerCommon: React.FC<BannerCommonProps> = ({
  data,
  cmsData,
  className,
  classValue,
  carrearpage,
  popUpData,
}) => {
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(false);
  const { isPopupVisible, hidePopup } = usePopupVisibility();
  const [BroutcherLink] = useState("");
  const [pageSlug, setPageSlug] = useState("");

  useEffect(() => {
    const slug = router.asPath.split("/").filter(Boolean).join("/");
    setPageSlug(slug || "home");
  }, [router.asPath]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const bannerHeight = isMobile
    ? data.MobileBannerHeight
    : data.DesktopBannerHeight;

  return (
    <section className={styles.heroVideo}>
      <div
        className={`${styles.BannerContainer} ${
          className ? styles.aboutBannerClass : ""
        } ${classValue ? styles.contactBannerClass : ""}`}
        style={{ height: `${bannerHeight}px` }}
      >
        {(isMobile ? cmsData?.mobile_img?.url : cmsData?.desktop_img?.url) && (
          <Image
            src={
              isMobile
                ? cmsData?.mobile_img?.url || ""
                : cmsData?.desktop_img?.url || ""
            }
            alt={
              isMobile
                ? cmsData?.mobile_img?.alternativeText || "School Hero Banner"
                : cmsData?.desktop_img?.alternativeText || "School Hero Banner"
            }
            title={
              isMobile
                ? cmsData?.mobile_img?.alternativeText || "School Hero Banner"
                : cmsData?.desktop_img?.alternativeText || "School Hero Banner"
            }
            fill
            style={{
              objectFit: "cover",
            }}
            className={styles.Banner}
            priority
          />
        )}
        <div className={styles.overlay}></div>
        <div className={styles.callout}>
          {cmsData?.title && (
            <h1
              className={carrearpage ? styles.tittleAlternate : styles.title}
              dangerouslySetInnerHTML={{ __html: cmsData?.title }}
            ></h1>
          )}
          {cmsData?.description && (
            <div className={carrearpage ? styles.desAlternate : styles.desc}>
              {cmsData?.description}
            </div>
          )}
          <div className={styles.btnContainer}>
            {cmsData?.cta && (
              (
              <CustomiseCta ctaData={cmsData?.cta} popupData={popUpData}  />
            )
            )}
          </div>
        </div>
      </div>
      {isPopupVisible && (
        <PopupForm
          isVisible={isPopupVisible}
          onClose={hidePopup}
          BroutcherLink={BroutcherLink}
          pageSlug={pageSlug}
        />
      )}
      {isPopupVisible && (
        <PopupForm
          isVisible={isPopupVisible}
          onClose={hidePopup}
          BroutcherLink={BroutcherLink}
          pageSlug={pageSlug}
        />
      )}
    </section>
  );
};

export default BannerCommon;
